import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/dist/ScrollTrigger"

const gsapProductFixedNoFeatures = {};

gsapProductFixedNoFeatures.init = () => {
    gsap.registerPlugin(ScrollTrigger);

    let fixedElem = ".js-gsap-fixed-product-specifics";

    if (document.querySelector(fixedElem)) {

        let sceneHero;

        ScrollTrigger.matchMedia({

            "(min-width: 1024px)": function() {

                sceneHero = function() {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".js-gsap-hero",
                            start: "center 60%",
                            end: "bottom top",
                            pin: fixedElem,
                            scrub: 1,
                            // toggleActions: "play pause resume reverse",
                            pinSpacing: false,
                            // markers: true
                        }
                    });
                    tl.to(fixedElem, {
                        duration: 1
                    });
                    return tl;
                }
            },

            // mobile
            "(max-width: 1023px)": function() {

                // avoid refresh on resize for mobile devices (for example in Android -> edge every time the address bar is hidden it automatically refresh)
                ScrollTrigger.config({
                    // default is "resize,visibilitychange,DOMContentLoaded,load" so we can remove "resize" from the list:
                    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"
                });

                sceneHero = function() {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".js-gsap-hero",
                            start: "80px top",
                            end: "top 10px",
                            pin: fixedElem,
                            scrub: 1,
                            // toggleActions: "play pause resume reverse",
                            pinSpacing: false,
                            // markers: true
                        }
                    });
                    tl.to(fixedElem, {
                        duration: 1
                    });
                    return tl;
                }

            }
        })

        let masterTimeline = gsap.timeline()
            .add(sceneHero())
    }

};

export default gsapProductFixedNoFeatures;
